<template>
  <el-col class="right_col_sidebar" :span="col_span">
    <div class="right_sidebar">
      <div class="right_sidebar__top" id="right_sidebar__top">
        <div
          class="right_sidebar__title title-container"
          :class="{ 'title-wrapper-task': !$route.params.chat_id }"
        >
          <router-link
            :to="closeTaskBody()"
            @click.native="closeTask"
            class="close_chats"
            v-if="$route.params.chat_id"
          >
            <img
              :src="require('@/assets/static/images/arrow_back.svg')"
              alt="arrow back"
            />
          </router-link>
          <RenameTaskName
            :task="task"
            :project_id="task.project_id"
            type="task"
          />
          <router-link
            :to="closeTaskBody()"
            @click.native="closeTask"
            class="close_right_sidebar"
            v-if="!$route.params.chat_id"
          >
            <i class="el-icon-close"> </i>
          </router-link>
        </div>

        <div class="right_sidebar__call_to_action">
          <AssignUser :key="$route.params.task_id" />
          <SetDeadline
            :key="$route.params.task_id + 1"
            :task_id="$route.params.task_id"
          />
          <SetReminder
            :key="$route.params.task_id + 2"
            :task_id="$route.params.task_id"
          />
        </div>

        <Notes :key="$route.params.task_id" :task_id="$route.params.task_id" />

        <button class="right_sidebar__notes__drag" id="changeNoteHeight">
          {{ $t("task.notes.drag") }}
          <img :src="require(`@/assets/static/images/note-arrow.svg`)" alt="" />
        </button>
      </div>

      <div class="right_sidebar__bottom" id="right_sidebar__bottom">
        <div class="right_sidebar__comments">
          <el-tabs
            v-model="activeTabName"
            type="card"
            @tab-click="change_att_coment_block"
            :before-leave="change_hook_tabs"
          >
            <el-tab-pane
              :label="$t('comments')"
              name="comment"
              class="is-active comments comments_list"
            >
              <Comments
                :key="$route.params.task_id"
                :date="task.date"
                :author="task.auth"
                :type="'list'"
              />
              <!-- 
                                Delay node was added so that animation works fine in chat page. 
                                If the chat has linked project and if the user wants to open a task 
                                from the project there should be an animation if the AddComment 
                                component is delayed in the dom it is working if there is no delay 
                                animation is not working properly
                            -->
              <AddComment :key="task._id + 1" v-if="delayNode" :type="'list'" />
            </el-tab-pane>
            <el-tab-pane :label="$t('attachments')" name="files">
              <Files :key="task._id + 2" />
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
    </div>
  </el-col>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from "vuex";
import AssignUser from "@/components/tasks/AssignUser";
import Notes from "@/components/tasks/Notes";
import SetDeadline from "@/components/tasks/SetDeadline";
import SetReminder from "@/components/tasks/SetReminder";
import Comments from "@/components/comment/Comments";
import AddComment from "@/components/comment/AddComment";
import Files from "@/components/files/Files";
import RenameElement from "@/components/app/RenameElement";
import { EventEmitter } from "../main";
import RenameTaskName from "../components/app/RenameTaskName.vue";

export default {
  name: "TaskBody",
  props: {
    chatPage: [Boolean],
  },
  data() {
    return {
      task: {},
      col_span: 8,
      task_created: "",
      task_created_time: "",
      task_author: "",
      activeTabName: "comment",
      project_id: "",
      noteHeight: "",
      task_messages: [],
      delayNode: false,
      renameComponentStyles: {},
    };
  },
  mounted() {
    if (!this.chatPage) {
      this.delayNode = true;
    }

    this.active_task();

    setTimeout(() => {
      this.delayNode = true;
    }, 500);

    EventEmitter.$on("afterTransition", () => {
      this.delayNode = true;
    });

    this.project_id = this.$route.params.project_id;

    EventEmitter.$emit("SearchInputClear", true);

    // this.task_messages = this.getComments[this.$route.params.task_id]

    this.set_task(this.$route);
    this.set_col_span();

    window.addEventListener(
      "resize",
      function (event) {
        let winHeight = window.innerHeight;
        // if (document.querySelector('#right_sidebar__bottom')) {
        //     document.querySelector('#right_sidebar__bottom').style.height = winHeight - document.querySelector('.right_sidebar__top').offsetHeight + 'px'
        // }
      },
      true
    );

    if (this.$route.params.task_id) {
      this.$w_taskData(this, this.project_id).forEach((e, i) => {
        if (e._id == this.$route.params.task_id) {
          e.users.forEach((user) => {
            if (user._id == this.getUserData._id) {
              let winHeight = window.innerHeight;
              this.noteHeight = user.note_size ? user.note_size : 130;
              document.querySelector(
                ".resizable-component.resizable"
              ).style.height = user.note_size ? user.note_size + "px" : "130px";
              // document.querySelector('#right_sidebar__bottom').style.height = winHeight - document.querySelector('.right_sidebar__top').offsetHeight + 'px'
            }
          });
        }
      });

      this.getAssigns.forEach((e) => {
        if (e.task_id == this.$route.params.task_id) {
          let data = {
            assign: e,
            update: false,
          };
          EventEmitter.$emit("AssignFind", data);
        }
      });
    }

    EventEmitter.$on("Note_Size", (data) => {
      this.$w_taskData(this, this.project_id).forEach((e, i) => {
        if (e) {
          if (e._id == data) {
            if (e._id == this.$route.params.task_id) {
              e.users.forEach((user) => {
                if (user._id == this.getUserData._id) {
                  const winHeight = window.innerHeight;
                  this.noteHeight = user.note_size
                    ? user.note_size + "px"
                    : "130px";
                  document.querySelector(
                    ".resizable-component.resizable"
                  ).style.height = user.note_size
                    ? user.note_size + "px"
                    : "130px";

                  // document.querySelector('#right_sidebar__bottom').style.height = winHeight - document.querySelector('.right_sidebar__top').offsetHeight + 'px'
                }
              });
            }
          }
        }
      });
    });

    EventEmitter.$on("onEditingNameChange", (value) => {
      if (document.querySelector(".right_sidebar__title")) {
        document.querySelector(".right_sidebar__title").style.height =
          value.height;
      }
    });

    // const resize = (elementId, buttonId) => {

    //     const element = document.getElementById(elementId)
    //     const button = document.getElementById(buttonId)
    //     const min = 54
    //     const max = 300
    //     const winHeight = window.innerHeight
    //     let h = ''
    //     let initialWidth = 0, initialHeight = 0, mouseX = 0, mouseY = 0

    //     button.addEventListener('mousedown', function(e) {
    //         button.style.cursor = 'grabbing'
    //         getMousePositions(e)
    //         getElementDimensions()
    //         window.addEventListener('mousemove', scale)
    //         window.addEventListener('mouseup', removeScale)
    //     })

    //     function getMousePositions(e) {
    //         mouseX = e.pageX
    //         mouseY = e.pageY
    //     }

    //     function getElementDimensions() {
    //         initialWidth = element.clientWidth
    //         initialHeight = element.clientHeight
    //     }

    //     const scale = (e) => {
    //         const height = initialHeight + (e.pageY - mouseY)
    //         if (height > min && height < max) {
    //             h = height
    //             element.style.height = height + 'px';
    //             document.querySelector('#right_sidebar__bottom').style.height = winHeight - document.querySelector('.right_sidebar__top').offsetHeight + 'px'
    //         }
    //     }

    //     const removeScale = () => {
    //         window.removeEventListener('mousemove', scale)
    //         this.sendNoteSize(h)
    //         button.style.cursor = 'grab'
    //         h = ''
    //     }

    // }

    // resize('notes-holder','changeNoteHeight')
  },
  methods: {
    ...mapMutations([
      "setMessage",
      "changeCommentLoading",
      "change_flag_for_files",
    ]),
    ...mapActions(["socket_fetch_comments", "socket_read_message"]),
    active_task() {
      document
        .querySelectorAll(".tasks_row_body.active")
        .forEach((e) => e.classList.remove("active"));

      setTimeout(() => {
        if (
          document.querySelector(
            `.task_box[data-id="${this.$route.params.task_id}"]`
          )
        ) {
          document
            .querySelector(
              `.task_box[data-id="${this.$route.params.task_id}"] .tasks_row_body`
            )
            .classList.add("active");
        }
      }, 100);
    },
    change_att_coment_block(tab, event) {
      EventEmitter.$emit("Files");
      // событие срабатывает при смене табов в правом блоке
      // console.log('tab');
    },
    sendNoteSize(height) {
      if (height != "") {
        this.$socket.emit("IN_Note_Size", {
          project_id: this.project_id,
          task_id: this.$route.params.task_id,
          size: height,
        });
      }
    },
    change_hook_tabs(activeName, oldActiveName) {
      document.getElementById(`pane-${activeName}`).classList.add("is-active");

      if (activeName == "files") {
        document.querySelectorAll(`.el-tab-pane`).forEach((element) => {
          element.classList.remove("default_value");
        });
      }

      document
        .getElementById(`pane-${oldActiveName}`)
        .classList.remove("is-active");
    },
    set_col_span() {
      setTimeout(() => {
        const project_body = document.querySelector(".project_body");

        if (project_body) {
          this.col_span = 24 - project_body.dataset.colSpan;
        }
      }, 100);
    },
    set_task(route) {
      if (this.$w_taskData(this, this.project_id)) {
        const findTask = this.$w_taskData(this, this.project_id).find(
          (task) => {
            if (task) {
              return task._id == route.params.task_id;
            }
          }
        );

        if (findTask) {
          this.task = findTask;
        }
      } else if (this.getCompletedTasks[this.project_id]) {
        const findCompleteTask = this.getCompletedTasks[this.project_id].find(
          (task) => task._id == route.params.task_id
        );

        if (findCompleteTask) {
          this.task = findCompleteTask;
        } else {
          this.task = {};

          this.$router.push(`/project/${this.project_id}`);

          const routerQuery = {
            key_message: "warning",
            message: this.$t("task.messages.no_task"),
          };

          this.setMessage(routerQuery);
        }
      }
    },
    closeTask() {
      document
        .querySelectorAll(".tasks_row_body.active")
        .forEach((e) => e.classList.remove("active"));
      document
        .querySelector(".right_col_sidebar")
        .classList.remove("run_anime");

      setTimeout(() => {
        if (this.$route.params.chat_id) {
          this.$router.push(`/chats/${this.$route.params.chat_id}`);
        } else {
          if (this.$route.name == "InboxTaskBody") {
            this.$router.push(`/inbox/${this.project_id}`);
          } else if (this.$route.params.shortcuts) {
            this.$router.push(`/shortcuts/${this.$route.params.shortcuts}`);
          } else {
            this.$router.push(`/project/${this.project_id}`);
          }
        }
      }, 150);
    },
    closeTaskBody() {
      return "";
      // if (this.$route.params.chat_id) {
      //     return `/chats/${this.$route.params.chat_id}`
      // } else {
      //     if (this.$route.name == 'InboxTaskBody') {
      //         return `/inbox/${this.project_id}`;
      //     } else if (this.$route.params.shortcuts) {
      //         return `/shortcuts/${this.$route.params.shortcuts}`;
      //     } else {
      //         return `/project/${this.project_id}`;
      //     }
      // }
    },
  },
  computed: {
    ...mapGetters([
      "getTasks",
      "getCompletedTasks",
      "get_flag_for_tasks",
      "getComments",
      "getUserData",
      "getAssigns",
      "getProjects",
      "get_active_task_window",
      "getRenderUserData",
    ]),
  },
  watch: {
    delayNode() {
      setTimeout(() => {
        document.getElementById("add_comment_block_list").focus();
      }, 10);
    },
    getRenderUserData() {
      this.activeTabName = "comment";

      document.querySelectorAll(`.el-tab-pane`).forEach((element) => {
        element.classList.add("default_value");
      });

      this.set_task(this.$route);
      this.set_col_span();

      if (!this.getComments[this.$route.params.task_id]) {
        this.fetch_comments(this.$route.params.task_id);
      }

      this.changeCommentLoading();
      this.change_flag_for_files();
    },
    $route(to) {
      let projectID = to.params.project_id;

      this.active_task();

      this.project_id = projectID;

      this.activeTabName = "comment";

      document.querySelectorAll(`.el-tab-pane`).forEach((element) => {
        element.classList.add("default_value");
      });

      this.set_task(to);
      this.set_col_span();

      // if (!this.getComments[this.$route.params.task_id]) {
      //     this.fetch_comments(this.$route.params.task_id)
      // }

      this.changeCommentLoading();
      this.change_flag_for_files();

      setTimeout(() => {
        EventEmitter.$emit("typing_render");
      }, 100);
    },
    get_flag_for_tasks(e) {
      if (this.$route.params.task_id) {
        this.set_task(this.$route);
        this.set_col_span();
      }
    },
  },
  components: {
    AssignUser,
    Notes,
    SetDeadline,
    SetReminder,
    Comments,
    AddComment,
    Files,
    RenameElement,
    RenameTaskName,
  },
};
</script>
